import React, { useEffect, useState } from 'react'

import { MessagePanel, BodyText, Label, Button } from '@pb/components'
import { useDispatch, useSelector } from 'react-redux'

import { operationKlarnaAuth } from '../../duck/operations'
import selectors from '../../duck/selectors'
import styles from './GetStartedMessage.scss'

const GetStartedMessage: React.FC = () => {
  const dispatch = useDispatch()
  const isKlarnaAuthRequested = useSelector(selectors.getIsKlarnaAuthRequested)
  const [shouldShowSpinner, setShouldShowSpinner] = useState(false)

  const handleGetStarted = (): any => {
    setShouldShowSpinner(true)
    dispatch(operationKlarnaAuth())
  }

  useEffect(() => {
    if (isKlarnaAuthRequested) {
      setShouldShowSpinner(true)
    }
  }, [isKlarnaAuthRequested])

  return (
    <MessagePanel title={<Label copyKey="omni.hmxklarna.getstarted.heading" />}>
      <BodyText className={styles.infoText}>
        <Label copyKey="omni.hmxklarna.getstarted.info" />
      </BodyText>
      <Button onClick={handleGetStarted} shouldShowSpinner={shouldShowSpinner}>
        <Label copyKey="omni.hmxklarna.getstarted.cta" />
      </Button>
    </MessagePanel>
  )
}

export default GetStartedMessage
